import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from './../../../../function/authService';
import { getUserById } from '../../../../api/auth';
import './profiledropdown.css';
import PBILD from "./../../../../images/plogo.png";

const DropdownImageTriggerExample = () => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const { userId } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getUserById(userId);
        setUser(data);
      } catch (error) {
        console.error('Fehler beim Laden des Benutzers:', error);
      }
    };

    if (userId) {
      fetchUser();
    }
  }, [userId]);

  const toggleDropdown = () => setOpen(!open);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const trigger = (
    <span className="profile-trigger">
      <img className="profile-avatar" src={user && user.image_url ? user.image_url : `${PBILD}`} alt="avatar" />
    </span>
  );

{/*
    const options = [
    { key: 'user', text: 'Account', icon: 'user', to: '/user/profile/settings' },
  ];
  */}

  return (
    <div className="profile-dropdown" ref={dropdownRef}>
      <div onClick={toggleDropdown}>
        {trigger}
      </div>
      {open && (
        <ul className="profile-dropdown-menu">
{/*
          {options.map(option => (
            <li key={option.key} className="profile-dropdown-item">
              <NavLink to={option.to}><i className={`profile-icon ${option.icon}`}></i> {option.text}</NavLink>
            </li>
          ))}
*/}
          <li key="sign-out" className="profile-dropdown-item profile-logout-item">
            <NavLink to="/signup" className="profile-logout-link">
              <button  onClick={() => logout(dispatch)} className="btn-gl profile-logout-button">Logout</button>
            </NavLink>
          </li>
        </ul>
      )}
    </div>
  );
};

export default DropdownImageTriggerExample;
